import { render } from "./ProductSalesPerStore.vue?vue&type=template&id=352e0a40"
import script from "./ProductSalesPerStore.vue?vue&type=script&lang=js"
export * from "./ProductSalesPerStore.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__